import VersionListing from './version-listing';

export default VersionListing;
